import React from 'react';

const PhoneInput = ({ 
    value = { countryCode: '+1', number: '' }, 
    onChange, 
    label, 
    error, 
    touched, 
    name,
    required = false,
    className = ""
}) => {
    const handleCountryChange = (e) => {
        onChange({
            ...value,
            countryCode: e.target.value
        });
    };

    const handleNumberChange = (e) => {
        const val = e.target.value.replace(/\D/g, '');
        onChange({
            ...value,
            number: val
        });
    };

    const countries = [
        { name: 'USA/Canada', code: '+1' },
        { name: 'Nepal', code: '+977' }
    ];

    return (
        <div className={`form-group mb-3 ${className}`}>
            {label && <label className="form-label small fw-semibold text-muted">{label} {required && <span className="text-danger">*</span>}</label>}
            <div className="input-group">
                <select 
                    className="form-select border-end-0" 
                    style={{ maxWidth: '100px' }}
                    value={value?.countryCode || '+1'}
                    onChange={handleCountryChange}
                >
                    {countries.map(c => (
                        <option key={c.code} value={c.code}>{c.code}</option>
                    ))}
                </select>
                <input
                    type="text"
                    name={name}
                    className={`form-control ${touched && error ? 'is-invalid' : ''}`}
                    placeholder="Phone number"
                    value={value?.number || ''}
                    onChange={handleNumberChange}
                />
            </div>
            {touched && error && <div className="invalid-feedback d-block">{error}</div>}
        </div>
    );
};

export default PhoneInput;
